import { PanelEditorScope } from "../panels/panel-editor-scope";
import { PanelWindowPropertiesDockingPanelContent } from "./content/panelWindowPropertiesDockingPanelContent";
import { DockingPanel } from "./dockingPanel";

export class PanelWindowPropertiesDockingPanel {
    private readonly panel: DockingPanel;
    private visible: boolean;

    constructor(container: HTMLElement, panelEditorScope: PanelEditorScope) {
        this.visible = false;

        const component = <PanelWindowPropertiesDockingPanelContent panelEditorScope={panelEditorScope} />;

        this.panel = new DockingPanel(
            container,
            "dextall-studio-panel-window-properties",
            "Window",
            component,
            {
                style: {
                    resize: "both",
                },
                dimensionsControl: {
                    preventOverlapsWithViewerToolbar: true,
                    widthDimensionControl: { value: 360, minValue: 360 },
                    heightDimensionControl: { value: 500, minValue: 500 },
                    topOffset: 2,
                    leftOffset: 364, // Positioned next to the Panel properties docking panel
                },
                nonStrictMode: true, // window area info uses @weave-design/flyout which triggers strict mode errors
            },
        );

        this.panel.addVisibilityListener((x: boolean) => (this.visible = x));
    }

    setVisible(visibility: boolean) {
        if (this.visible === visibility) {
            return;
        }
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }
}